import tokenService from "./tokenService";
import axiosClient from "api/axiosClient";
import { API_ROUTES } from "utils/constants";

const authService = {
    saveSession(session) {
        tokenService.save(session.token, session.expiration);
    },

    clearSession() {
        tokenService.clear();
    },

    async login(data) {
        const response = await axiosClient.post(API_ROUTES.LOGIN, data);
        return response.data;
    },

    async me() {
        const response = await axiosClient.get(API_ROUTES.ME);
        return response.data;
    }
};

export default authService;
